import useVerify from '../hooks/useVerify';
import useAlert from '../hooks/useAlert';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";

const Verify = () => {
	const { t } = useTranslation();
	const { verifyState, onClickCancel, onClickConfirm } = useVerify();
	const { status, title, message } = verifyState;
	const [verificationCode, setVerificationCode] = useState('');
	const navigate = useNavigate();
	const { sendAlert } = useAlert();

	const verifyEmail = (event) => {
		event.preventDefault();
		if (verificationCode) {
			// console.log(verificationCode)
			axios.post('/user/auth/verification_code', {
				accountId: message,
				verifyCode: verificationCode,
			}).then((response) => {
				const message = response.data.message;
				if (message === 'This user is already authenticated') {
					sendAlert(t('account.signup_hint_verified'));
				}
				if (message === 'success') {
					sendAlert(t('account.signup_hint_verified_success'));
				}
				onClickConfirm();
				// navigate('/login');
			}).catch((error) => {
				const message = error.response.data.message;
				switch (message) {
					case 'Verification code is not matched':
						sendAlert(t('account.signup_hint_wrong_code'));
						break;
					case 'Bad request':
						sendAlert('Bad request', message);
						break;
					default:
						sendAlert('Oops!', message);
						break;
				}
			});
		}
	}

	return (
		<div className={`common-confirm ${status ? 'active' : ''}`}>
			<form className='center-wrap' onSubmit={verifyEmail}>
				<div className='title'>{title}</div>
				<input type='text' onChange={(e) => {
					setVerificationCode(e.target.value);
				}} value={verificationCode} placeholder='請輸入驗證碼' />
				<div className='button-wrap'>
					<button className='button cancel' onClick={onClickCancel}>{t('confirm.no')}</button>
					<button className='button'>{t('confirm.yes')}</button>
				</div>
			</form>
		</div>
	)
}

export default Verify;